import { Megaphone, Eye, MousePointerClick, Target, Wallet, ShieldAlert } from 'lucide-react';
import type { PromotedListing } from '@/client/types/promotion';
import { StatTile, ListingThumb, numberFmt } from './atoms';
import { money, RISK_META } from './listingMetrics';

/** View rate isn't in the payload — it's views ÷ impressions on the rollup. */
const viewRate = (listing: PromotedListing) =>
  listing.impressions > 0 ? listing.views / listing.impressions : 0;

export const ListingHeaderCard: React.FC<{ listing: PromotedListing }> = ({ listing }) => (
  <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
    <div className="flex items-center gap-4 bg-gradient-to-br from-indigo-500 to-purple-600 px-6 py-5">
      <ListingThumb
        cover={listing.listing.cover}
        name={listing.listing.name_basic}
        className="h-14 w-14 rounded-xl text-lg ring-1 ring-white/30"
      />
      <div className="min-w-0 flex-1">
        <h2 className="truncate text-xl font-bold text-white">{listing.listing.name_basic}</h2>
        <p className="text-sm text-white/80">
          {listing.listing.type_name} · Owner: {listing.listing.owner.name} · EID {listing.eid}
        </p>
      </div>
      <span className="hidden rounded-full bg-white/15 px-2.5 py-1 text-xs font-medium text-white ring-1 ring-white/25 sm:inline-flex">
        {(RISK_META[listing.risk] ?? RISK_META.low).label}
      </span>
    </div>
    <div className="grid grid-cols-2 gap-3 p-4 lg:grid-cols-3 2xl:grid-cols-6">
      <StatTile icon={Megaphone} label="Active packages" value={String(listing.active_count)} tone="bg-indigo-50 text-indigo-600" />
      <StatTile icon={Eye} label="Impressions" value={numberFmt.format(listing.impressions)} tone="bg-emerald-50 text-emerald-600" />
      <StatTile icon={MousePointerClick} label="Views" value={numberFmt.format(listing.views)} tone="bg-lime-50 text-lime-600" />
      <StatTile icon={Target} label="View rate" value={`${(viewRate(listing) * 100).toFixed(1)}%`} tone="bg-amber-50 text-amber-600" />
      <StatTile icon={Wallet} label="Total spent" value={money(listing.total_spend)} tone="bg-teal-50 text-teal-600" />
      <StatTile icon={ShieldAlert} label="Fill rate" value={`${Math.round(listing.fill * 100)}%`} tone="bg-rose-50 text-rose-600" />
    </div>
  </div>
);
